import { getLessonsUtil } from '../../main/utils/asset/lessons.util.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectCurrentLessonTaskStep } from './current-lesson-task-step.selector.ts';

export const selectCurrentStepParts = createMemoizedSelector(
  selectCurrentLessonTaskStep,
  (currentLessonTaskStep): string[] | null => {
    const { task, step } = currentLessonTaskStep;
    return getLessonsUtil().getStepParts(task, step);
  }
);
